import { HeatTabs } from './HeatTabs';
import { useEffect, useState, Dispatch, SetStateAction } from 'react';
import { Heat } from 'functions/src/types/firestore/Game/Tournament/Heat';
import { Required } from 'utility-types';
import { RefereeHeader } from 'src/components/referee-portal/RefereeHeader';
import { useAuth } from 'src/contexts/AuthContext';
import { isAdmin } from 'functions/src/types/firestore/User/util';
import { HeatTabsContent } from './HeatTabsContent';
import { SingleTournamentProps } from '../SingleTournament';

export type TabHeat = Required<
  Pick<Heat<Date>, 'title' | 'startTime' | 'rounds' | 'prizes'>,
  'rounds'
> & { isDoubleElimination: boolean };

export type HeatsBracket = {
  heats:
    | TabHeat[]
    | { winner: TabHeat[]; loser: TabHeat[]; grandFinal: TabHeat[] };
};

export type HeatsBracketTabProps = Pick<SingleTournamentProps, 'gameId'> & {
  setIsBracketLoading: Dispatch<SetStateAction<boolean>>;
};

export const HeatsBracketTab = ({
  setIsBracketLoading,
  gameId,
}: HeatsBracketTabProps) => {
  useEffect(() => {
    setIsBracketLoading(false);
  }, []);
  const { userData } = useAuth();
  const isAuthenticated = isAdmin(userData?.email);
  const [selectedHeatIndex, setSelectedHeatIndex] = useState<number>(0);

  return (
    <>
      <HeatTabs
        selectedHeatIndex={selectedHeatIndex}
        setSelectedHeatIndex={setSelectedHeatIndex}
      />
      {!!isAuthenticated && <RefereeHeader />}
      <HeatTabsContent selectedHeatIndex={selectedHeatIndex} />
    </>
  );
};
